import React from "react";
import "../DSInfoContainer.css";
import { handleInputChange, handleWalkWayType } from "../DSFunction";
import { useDispatch, useSelector } from "react-redux";

export default function ShedOption({ handleKeyPress }) {
  const dispatch = useDispatch();
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];

  return (
    <div className="formWithLabel shedForm">
      <div className="formShedInfo">
        <label>Side Spacing({gridInfo.unit})</label>
        <input
          type="text"
          value={roofDetail.sideSpace}
          name="sideSpace"
          onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
          onKeyPress={(e) => handleKeyPress(e)}
          disabled={roofDetail.customCapacityType === "Custom" ? false : true}
          style={
            roofDetail.customCapacityType === "Custom"
              ? {}
              : { backgroundColor: "#E9ECEF" }
          }
        ></input>
      </div>
      <div className="formShedInfo">
        <label>Walk-way</label>
        <div className="walkWayParameter">
          <span
            onClick={() =>
              handleWalkWayType("With", dispatch, roofIndex, roofDetail)
            }
            style={
              roofDetail.walkWayType === "With"
                ? { backgroundColor: "#FF7C1B" }
                : {}
            }
          >
            With Walkway
          </span>
          <span
            onClick={() =>
              handleWalkWayType("Without", dispatch, roofIndex, roofDetail)
            }
            style={
              roofDetail.walkWayType === "Without"
                ? { backgroundColor: "#FF7C1B" }
                : {}
            }
          >
            Without Walkway
          </span>
        </div>
      </div>
      <div className="formShedInfo">
        <label>No of row</label>
        <input
          type="text"
          value={roofDetail.blockRow}
          name="blockRow"
          onChange={(e) => {
            handleInputChange(e, dispatch, roofIndex);
          }}
          onKeyPress={(e) => handleKeyPress(e)}
          disabled={
            roofDetail.customCapacityType === "Custom" &&
            roofDetail.walkWayType === "With"
              ? false
              : true
          }
          style={
            roofDetail.customCapacityType === "Custom" &&
            roofDetail.walkWayType === "With"
              ? {}
              : { backgroundColor: "#E9ECEF" }
          }
        ></input>
      </div>
      <div className="formShedInfo">
        <label>No of column</label>
        <input
          type="text"
          value={roofDetail.blockCol}
          name="blockCol"
          onChange={(e) => {
            handleInputChange(e, dispatch, roofIndex);
          }}
          onKeyPress={(e) => handleKeyPress(e)}
          disabled={
            roofDetail.customCapacityType === "Custom" &&
            roofDetail.walkWayType === "With"
              ? false
              : true
          }
          style={
            roofDetail.customCapacityType === "Custom" &&
            roofDetail.walkWayType === "With"
              ? {}
              : { backgroundColor: "#E9ECEF" }
          }
        ></input>
      </div>
    </div>
  );
}
